import { ToggleButtonGroup } from "@mui/material";
import styled from "@emotion/styled";
import { ZIndexLevels } from "../risk/geoUtils";

/**
 * A styled container for the navigation bar.
 */
export const NavBarContainer = styled.div( {
    position: "sticky",
    display: "flex",
    bottom: "0",
    height: "56px",
    width: "100%",
    justifyContent: "center",
    backgroundColor: "white",
    zIndex: ZIndexLevels.BeneathDrawerUiElement
} );

/**
 * A styled toggle button group that removes the left, right, and top borders.
 */
export const StyledToggleButtonGroup = styled( ToggleButtonGroup )( {
    border: "none",
    "& .MuiToggleButton-root": {
        borderLeft: "none",
        borderRight: "none",
        borderTop: "none",
    },
} );
